<script>
  import DeleteIcon from './DeleteIcon'

  export default {
    name: 'RemoveButton',

    components: {
      DeleteIcon,
    },

    emits: ['click'],

    methods: {
      emitClick() {
        this.$emit('click')
      },
    },
  }
</script>

<template>
  <button
    class="button remove"
    @click="emitClick"
  >
    <delete-icon
      fill="#888"
      width="15"
    />
  </button>
</template>

<style lang="stylus" scoped>
@import "./ListButton.styl"

.remove
  color #888
</style>
